import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyHelperService } from '../../core/helpers/currency-helper.service';

@Pipe({
	name: 'customCurrency'
})
export class CustomCurrencyPipe extends CurrencyPipe implements PipeTransform {


	transform(value: number, currency: any = 'NGN') {
		currency = currency && currency.trim();
		if ((!isNaN(value) && value) || value === 0) {
			let pipeOutput;

			if (!isNaN(currency)) {
				currency = CurrencyHelperService.getAlphabetCurrencyCode(currency);
			}

			if (!currency) {
				return;
			}
			// Format Currency;
			if (currency === 'NGN') {
				const money = `${value}`;
				const dotPosition = money.lastIndexOf('.');
				const newValue = dotPosition && dotPosition >= 0 ? money.substring(0, dotPosition) : money;
				pipeOutput =
					new DecimalPipe('en').transform(newValue, '1.0-0');
			} else if (currency === 'USD') {
				pipeOutput =
					'$' + new DecimalPipe('en').transform(value, '1.2-2');
			} else if (currency.startsWith('-')) {
				pipeOutput =
					new DecimalPipe('en').transform(value, '1.2-2');
			} else {
				pipeOutput = super.transform(value, currency, true, '1.2-2');
			}
			return pipeOutput;
		} else {
			return value;
		}
	}

	numberWithoutCommas(x) {
		return x.toString().replace(/(\.\d{2})\d*/, '$1');
	}

	numberWithCommas(x) {
		return x.toString().replace(/(\.\d{2})\d*/, '$1').replace(/(\d)(?=(\d{3})+\b)/g, '$1,');
	}

}
